import React, { useContext, useState } from 'react';
import context from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { withConfig } from '@catalogo/core-connect/config';
import compose from 'lodash/fp/compose';
import { IFeedbackContext, IInjectedProps, TProps } from '../../types';

const withFeedbackReview = (Component: React.FC<TProps & IInjectedProps>) => (
  props: Omit<TProps, keyof IInjectedProps>
) => {
  const { config, actionFeedback, dispatchMetrics } = useContext<IFeedbackContext>(context);
  const [like, setLike] = useState(false);
  const [dislike, setDislike] = useState(false);
  const { customer } = config;
  const handleLike = () => {
    setLike(!like);
    if (!like) {
      dispatchMetrics('event:track', {
        category: 'avaliacao-pdp',
        action: 'avaliacao-feedback',
        label: 'curti',
      });
    }
  };

  const handleDislike = () => {
    setDislike(!dislike);
    if (!dislike) {
      dispatchMetrics('event:track', {
        category: 'avaliacao-pdp',
        action: 'avaliacao-feedback',
        label: 'nao-curti',
      });
    }
  };

  const handleFeedback = async (vote: string, id: string) => {
    if (!customer?.id) {
      const currentHref = globalThis.location.href;
      const urlLogin = `https://cliente.${config?.brandName.toLocaleLowerCase()}.com.br/minha-conta/entrar`;
      globalThis.location.href = `${urlLogin}?next=${currentHref}`;
    }

    const result = await actionFeedback({
      variables: {
        reviewId: id,
        vote: vote,
      },
    });

    if (result) {
      if (vote == 'upvote') {
        handleLike();
        setDislike(false);
        return;
      }
      if (vote == 'downvote') {
        handleDislike();
        setLike(false);
        return;
      }
    }
  };

  const data = { ...props, handleFeedback: handleFeedback, like: like, dislike: dislike };
  return <Component {...data} />;
};

export default compose(withConfig, withFeedbackReview);
export { withFeedbackReview };
